var useGoogleAnalytics = true // используй false пока девелопишь и дебажишься

// var host = 'https://server.vsevse.com/api/' // PRODUCTION
var host = 'https://server.ktokuda.rokkets.ru/api/' // DEV server
// var host = 'http://localhost:1750/api/' // DEV localhost

// var filesHost = 'https://server.vsevse.com/api/' // PRODUCTION
var filesHost = 'https://server.ktokuda.rokkets.ru/api/' // DEV server
// var filesHost = 'http://localhost:1750/api/' // DEV localhost

const appSettings = {
  appName: 'Всездесь',
  appVer: 'v0.57 26.01.22', // перерыв с '17.10.21' до 17.12.21. потом с 19.12.21 до 15.01.22

  company: null,
  companies: {
    'VSEZDES': {name: 'ВСЕЗДЕСЬ'}
  },
  // welcomePage: '/admin',
  // userProfilePage: './admin/profile',

  companiesConfigs: {
    'VSEZDES': {
      appModules: {
      }
    }
  },

  useGoogleAnalytics: useGoogleAnalytics,

  server: {
    hostName: null,
    host: null,
    hosts: {
      'VSEZDES': host
    },

    modelsNotifierSubscription: 'system/subscribeToRoomOrModel',

    settings: host + 'settings/findBugfixed',
    commonSettingsCriteria: '?where={"uniqueName":["commonSettings"]}',
    eventsSettingsCriteria: '?where={"uniqueName":["eventsSettings"]}',

    fileEntityResource: filesHost + 'fileEntity',

    userSignup: host + 'user/signup',
    userLogin: host + 'user/login',
    userGetActiveUser: host + 'user/getActiveUser',
    userLogout: host + 'user/logout',
    userActiveChangePassword: host + 'user/activeUserChangePassword',
    userActiveChangeName: host + 'user/activeUserChangeName',
    userResource: host + 'user',
    // userGroupResource: host + 'userGroup',

    placeResource: host + 'place',

    eventResource: host + 'event', // у этого rest-resource есть find. но базово вместо него getMyEventsTimeline
    getMyEventsTimeline: host + 'event/getMyEventsTimeline', // возвращает events, eventsUsers, eventsMembers
    getMyEvents: host + 'event/getMyEvents', // это не timeline а события сделанные пользователем. для редактирования. возвращает events, eventsUsers, eventsMembers
    eventChangeStatus: host + 'event/changeStatus',

    eventMemberResource: host + 'eventMember'

    // apiVer: 'v1.0/'
    // ajaxRequestTimeout: 5000 //5 sec
  }
}

export default {
  state: {
    appSettings: appSettings
  },
  getters: {
    appSettings: state => state.appSettings
  },
  mutations: {
    serverHostSet (state, newServerHostName) {
      state.appSettings.server.hostName = newServerHostName
      state.appSettings.server.host = state.appSettings.server.hosts[newServerHostName]
      state.appSettings.company = state.appSettings.companies[newServerHostName]
      if (state.appSettings.company != null) state.appSettings.company.config = state.appSettings.companiesConfigs[newServerHostName]
    }
  }
}



// WEBPACK FOOTER //
// ./src/settings.js